import { useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Seo from "@/components/Seo";
import { ChevronRight } from "lucide-react";

export default function LegalPageLayout({
  category,
  title,
  lastUpdated,
  sections,
  testid,
  seoDescription,
  seoPath,
}) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [seoPath]);

  return (
    <div
      data-testid={testid}
      className="min-h-screen bg-white dark:bg-slate-950 text-slate-900 dark:text-slate-100"
    >
      <Seo title={title} description={seoDescription} path={seoPath || "/"} />
      <Navbar />
      <main className="pt-28 pb-24">
        <div className="mx-auto max-w-3xl px-6 lg:px-8">
          {/* Breadcrumb */}
          <nav className="flex items-center text-xs text-slate-500 dark:text-slate-400 gap-1">
            <Link to="/" className="hover:text-emerald-600 dark:hover:text-emerald-400">
              Hem
            </Link>
            <ChevronRight className="h-3 w-3" />
            <span className="text-slate-700 dark:text-slate-200">{category}</span>
          </nav>

          {/* Header */}
          <header className="mt-8 pb-8 border-b border-slate-200 dark:border-slate-800">
            <div className="text-xs uppercase tracking-[0.2em] font-semibold text-emerald-600 dark:text-emerald-400">
              {category}
            </div>
            <h1 className="font-display mt-3 text-4xl sm:text-5xl font-bold tracking-tight text-slate-900 dark:text-white">
              {title}
            </h1>
            {lastUpdated && (
              <p className="mt-4 text-sm text-slate-500 dark:text-slate-400">
                Senast uppdaterad: {lastUpdated}
              </p>
            )}
          </header>

          {/* Sections */}
          <article className="mt-10 space-y-10">
            {sections.map((s, i) => (
              <section key={s.title} id={`section-${i + 1}`} className="scroll-mt-28">
                <h2 className="font-display text-2xl font-semibold text-slate-900 dark:text-white">
                  {i + 1}. {s.title}
                </h2>
                <div className="mt-4 space-y-4 text-slate-600 dark:text-slate-300 leading-relaxed">
                  {s.body.map((b, j) =>
                    Array.isArray(b) ? (
                      <ul key={j} className="list-disc pl-6 space-y-2 marker:text-emerald-500">
                        {b.map((item) => (
                          <li key={item}>{item}</li>
                        ))}
                      </ul>
                    ) : (
                      <p key={j}>{b}</p>
                    )
                  )}
                </div>
              </section>
            ))}
          </article>

          {/* Contact note */}
          <div className="mt-16 rounded-2xl border border-slate-200 dark:border-slate-800 bg-slate-50 dark:bg-slate-900 p-6">
            <h3 className="font-display text-lg font-semibold text-slate-900 dark:text-white">
              Frågor?
            </h3>
            <p className="mt-2 text-sm text-slate-600 dark:text-slate-300">
              Hör av dig via vår kontaktsida eller använd &ldquo;Boka en Demo&rdquo;-knappen, så
              hjälper vi dig vidare.
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
